// The broad SDK error families (Milestone 6.10/ADR-026).
//
// Category answers "which part of the SDK failed?" and is deliberately kept
// SEPARATE from `code`, which answers "exactly what failed?". That separation
// is what lets a publisher write either
//
//   if (error.category === ErrorCategory.WRAPPER) { ... }        // broad
//   if (error.code === ErrorCode.SDK_VAST_WRAPPER_LOOP) { ... }  // specific
//
// without the two ever fighting. It also replaces the string sniffing this
// milestone removed from VideoMetricsBinding, which classified wrapper
// failures with `error.name.startsWith('Wrapper')`.
//
// NETWORK is a category rather than a class: the SDK already has two concrete
// network error families (VastLoaderError for VAST fetches, DisplayRequestError
// for creative fetches), so a third generic NetworkError class nothing throws
// would be cosmetic hierarchy. Network-ness is expressed here and in the codes.
export const ErrorCategory = Object.freeze({
  CONFIGURATION: 'CONFIGURATION',
  NETWORK: 'NETWORK',
  VAST: 'VAST',
  WRAPPER: 'WRAPPER',
  PLAYBACK: 'PLAYBACK',
  TRACKING: 'TRACKING',
  DISPLAY: 'DISPLAY',
  LIFECYCLE: 'LIFECYCLE',
  // Backend API (Milestone 7.3) - the PlayBid backend answered, but rejected
  // the request or returned something unusable. Deliberately separate from
  // NETWORK, which means the request never got an answer at all: a publisher
  // retries a NETWORK failure and fixes configuration for an API one.
  API: 'API',

  // Read-aloud protocol (Milestone 8.1) - the manifest/status endpoints
  // answered, but rejected the request or reported the feature unavailable
  // for this site. Kept separate from NETWORK for the same reason API is:
  // NETWORK means the request never got an answer at all.
  READ_ALOUD: 'READ_ALOUD',

  // Contextual ads (in-text links, contextual commerce) - the keyword/product
  // endpoints answered, but with an error status or an unusable body. Kept
  // separate from NETWORK for the same reason API/READ_ALOUD are.
  CONTEXTUAL: 'CONTEXTUAL',

  INTERNAL: 'INTERNAL',
});
